// @flow
import React from "react";
import { Field } from "redux-form";
import { Form } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

import FormLabel from "Commons/Components/FormComponents/components/FormLabelWithDivider";
import { isRequired, is18orOlder } from "../../ChangeServices/submodules/Old_Edit/misc/Validators";
import { DateSelectField } from "../../ChangeServices/submodules/Old_Edit/components/Fields";

type Props = {
  mobileChangeService?: boolean,
  width?: number,
  noLabel?: boolean,
  divider?: boolean,
};

const EIGHTEEN_YEARS_AGO = 117; //- 100 -18 +1 (starts the years - 117 years ago, and it shows by default the next 100 years as options )

export const DateOfBirth = ({ mobileChangeService, noLabel, width, divider }: Props) => {
  const { t } = useTranslation("changeService");
  return (
    <>
      <Form.Group width={width} data-cy="dateOfBirth">
        {!noLabel && (
          <FormLabel
            divider={divider}
            title={t("common:birthDate")}
            inline
            tooltip={t("wizard.customer.birthDateTooltip")}
            secondary
          />
        )}
        <Field
          name="dateOfBirth"
          validate={[isRequired, is18orOlder]}
          component={DateSelectField}
          props={{ mobileChangeService, width: width, startYear: new Date().getFullYear() - EIGHTEEN_YEARS_AGO }}
        />
      </Form.Group>
    </>
  );
};
